export const getDecodedSign = (bufferData) => {
  const uint8Array = new Uint8Array(bufferData);
  return new TextDecoder().decode(uint8Array);
};
